module.exports = __webpack_public_path__ + "img/27.03b2241a.png";